import React from 'react';

/**
 * @function TitleText
 * @param {JSX.Element} children
 * @return {JSX.Element}
 * @constructor
 */
const TitleText = ({subtitle,title}) => {
    return (
        <>
            <div className="uppercase retro-gaming text-lg md:text-xl xl:text-2xl 2xl:text-3xl bg-clip-text text-white text-center mb-3 xl:mb-5">
                {subtitle}
            </div>
            
            <div className={`
                uppercase retro-gaming text-xl md:text-2xl xl:text-5xl 2xl:text-7xl font-extrabold 
                text-transparent text-center bg-clip-text bg-gradient-to-t 
                from-app-yellow to-app-red
            `}>
                {title}
            </div>
        </>
    );
}

export default TitleText;
